export const SECTION_CARD_CLASS =
  "min-w-0 max-w-full space-y-4 rounded-xl border border-slate-200/70 bg-white p-4 shadow-sm";

/**
 * Blocs de TEXTE qui exposent le traitement de texte complet (taille, alignement,
 * casse, italique/souligné/barré) dans l'onglet Design. Les autres blocs gardent
 * uniquement Couleurs + Typographie (police/graisse).
 *
 * Un bloc n'est listé ici QUE si son rendu applique réellement `style.design.text`
 * sur l'élément de texte (inline, pour battre ses classes Tailwind) — sinon les
 * contrôles seraient visibles mais sans effet. Heading/Button : style inline sur
 * l'élément (`useBlockTextCss`/`useBlockStyleCss`). RichText : cascade via wrapper.
 * ArtworkSelection : `useBlockTextCss` appliqué inline sur chaque ligne de légende.
 * ItemSpotlight / CatalogueDecoupage : `useBlockTextCss` sur le libellé sous la vignette.
 */
export const TEXT_TREATMENT_BLOCKS = new Set<string>([
  "Heading",
  "RichText",
  "Button",
  "CatalogueCtaButton",
  "ArtworkSelection",
  "ItemSpotlight",
  "CatalogueDecoupage",
  "CatalogueDecoupages",
  "Quote",
  "Cta",
  "Banner",
  "Media",
]);

/**
 * Blocs « self » atomiques (Bouton/Icône) : le style va sur leur propre élément,
 * pas sur un StyleWrapper. Depuis l'unification (Phase 3), ils portent EUX-MÊMES
 * la classe + les règles générées (responsive/visibilité/attributs, cf.
 * ButtonBlock/IconBlock) → seuls restent masqués :
 *  - l'image de fond (pas de sens sur un élément ajusté au contenu) ;
 *  - la « Mise en page » (largeur/alignement/z-index — leur prop `align` et le
 *    flux inline-flex s'en chargent).
 * Le champ « Apparence » du Bouton ne garde que le SURVOL (bordures/rayons =
 * Design partagé, prioritaire sur l'apparence legacy).
 */
export const WRAPPERLESS_BLOCKS = new Set<string>([
  "Button",
  "CatalogueCtaButton",
  "Icon",
]);
export const NO_BACKGROUND_IMAGE_BLOCKS = WRAPPERLESS_BLOCKS;
export const NO_LAYOUT_BLOCKS = WRAPPERLESS_BLOCKS;
/**
 * Alignement texte Design masqué : le Contenu gère le positionnement du bloc
 * (blocs sans wrapper), ou le bloc est centré par construction (Bandeau : une
 * valeur déjà stockée est ignorée au rendu, cf. withoutTextAlign).
 */
export const NO_DESIGN_TEXT_ALIGN_BLOCKS = new Set<string>([
  ...WRAPPERLESS_BLOCKS,
  "Banner",
]);

/**
 * Seuls les blocs de texte courant proposent « Justifié » : sur une ligne
 * unique (titre, bouton), justifié = aligné à gauche, ce qui surprend.
 */
export const JUSTIFY_TEXT_BLOCKS = new Set<string>(["RichText", "Quote"]);

/** Blocs conteneurs dont la disposition se surcharge par appareil (FlowControls). */
export const FLOW_BLOCKS = new Set<string>([
  "Container",
  "Columns",
  "Grid",
  "TextImage",
  "CatalogueListing",
  "CatalogueSearchResults",
]);
